import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import AuxiliaryPurfier from "../components/auxiliary-Purfier";
import SisLoader from "../../../../widgets/loader";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";

const AuxilaryPurfierLog = () => {
  const { eng_log_basic_id } = useParams();
  const [loader, set_loader] = useState(false);
  const [purfier_Data, set_Purfier_Data] = useState([]);

  const GET_SHIP_PURFIER_LISTS = async (ship_Id) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", ship_Id);
      post(ApiURL.list_ship_purifier_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_loader(false);
          set_Purfier_Data(res?.response_data);
        }
      });
    } catch (error) {
      set_loader(false);
      console.error("Error Purfier list:", error);
    }
  };

  useEffect(() => {
    const ship_id = JSON.parse(localStorage.getItem("ship_id"));
    GET_SHIP_PURFIER_LISTS(ship_id);
  }, []);

  return (
    <>
      <div className="white-container">
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {purfier_Data?.length > 0 ? (
              <>
                {purfier_Data?.map((_items) => (
                  <>
                    <AuxiliaryPurfier eng_log_basic_id={eng_log_basic_id} _items={_items} />
                  </>
                ))}
              </>
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AuxilaryPurfierLog;
